import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-check-double-line', text: t('trust.item1') },
    { icon: 'ri-camera-line', text: t('trust.item2') },
    { icon: 'ri-secure-payment-line', text: t('trust.item3') },
    { icon: 'ri-refund-2-line', text: t('trust.item4') },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-white">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center tracking-tight">
          {t('trust.title')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {items.map((item, idx) => (
            <div key={idx} className="text-center p-6">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <p className="text-sm text-foreground-700 font-medium">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}